import { responsivePaddingDefault } from '@/libs/material/sx';
// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR, DS_WIDTH } from '@calm/evexia-design-tokens';
import { Theme } from '@rhg/libs/material';

export const styleOuterWrapper = {
    minHeight: '100dvh',
    width: '100%',
    background: (theme: Theme) => theme.palette.gradient.backgroundPrimary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export const styleFormOuterWrapper = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export const styleForm = {
    width: '100%',
};

export const styleContainer = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    flexGrow: 1,
    py: (theme: Theme) => `${theme.semantics.Spacing[40]}px`,
};
export const styleContent = {
    width: '100%',
    maxWidth: `${DS_WIDTH.FORM_MAX_WIDTH}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mx: responsivePaddingDefault,
};

export const styleAddEditButtonGroup = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    px: responsivePaddingDefault,
};

export const styleAddEditButton = { backgroundColor: 'background.paper' };

export const styleFormIconWrapper = {
    pt: (theme: Theme) => `${theme.semantics.Spacing[40]}px`,
    mb: (theme: Theme) => `${theme.semantics.Spacing[16]}px`,
};

export const styleCopyBlock = {
    pb: (theme: Theme) => `${theme.semantics.Spacing[40]}px`,
};

export const styleVerticalSpacing = {
    my: (theme: Theme) => `${theme.semantics.Spacing[40]}px`,
};

export const styleFooterActions = {
    py: 3,
    px: responsivePaddingDefault,
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? 'background.paper'
            : DS_COLOR.BLACK_40P,
    borderTop: `1px solid ${DS_COLOR.BLACK_12P}`,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const styleFooterActionsTransparent = {
    py: 3,
    px: responsivePaddingDefault,
    backgroundColor: 'transparent',
    borderTop: `1px solid ${DS_COLOR.BLACK_12P}`,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const styleButtonGroup = {
    maxWidth: `${DS_WIDTH.FORM_MAX_WIDTH}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: (theme: Theme) => `${theme.semantics.Spacing[16]}px`,
};
export const styleFlexGrow = { flexGrow: 1 };
